import { faImage } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { IdleStateProps } from '../../../types/drop-zone'
import useStateChildrenStyles from './useStateChildrenStyles'

const Idle = ({ acceptedMimeTypes }: IdleStateProps): React.ReactElement => {
  // TODO: generate icons based on allowed MimeTypes
  const { classes, cx } = useStateChildrenStyles()
  return (
    <FontAwesomeIcon
      icon={faImage}
      className={cx(classes.icon, classes.accept)}
    />
  )
}

export default Idle
